import { formatLocalDateUTC } from 'utils/date'

import { GridColumn } from './CampaignDetailsResultsPage'

const luckyDrawResultsColumns: GridColumn[] = [
  {
    field: 'date',
    title: 'Date',
    show: true,
    width: 170,
    sortable: false,
    cell: (props) => {
      const value = props.dataItem?.date
      return <td>{formatLocalDateUTC(value, true)}</td>
    },
  },
  {
    field: 'client.name',
    title: 'Client name',
    show: true,
    width: 220,
    sortable: false,
  },
  {
    field: 'campaignLuckyDrawActivityType.name',
    title: 'Activity',
    show: true,
    width: 160,
    sortable: false,
  },
  {
    field: 'resultType',
    title: 'Result',
    show: true,
    sortable: false,
    cell: (props) => {
      const { amount, resultType } = props.dataItem || {}
      return <td>{`${amount ?? ''} ${resultType ?? ''}`.trim()}</td>
    },
  },
]

export default luckyDrawResultsColumns
